export const SOURCES_PICKER_PACK_TTL_MS = 60_000;

/**
 * @param {string} sessionId
 * @returns {string}
 */
function storageKey(sessionId) {
	return `naxos_sources_picker_pack:${sessionId}`;
}

/**
 * @param {string} sessionId
 * @param {{ source?: string|null, identifier?: string|number|null, blocks?: unknown[] }} pack
 */
export function writeSourcesPickerPack(sessionId, pack) {
	if (!sessionId || !pack) {
		return;
	}

	const body = {
		writtenAt: Date.now(),
		pack,
	};

	try {
		localStorage.setItem(storageKey(sessionId), JSON.stringify(body));
	} catch {
		// Quota / private mode.
	}
}

/**
 * @param {string} sessionId
 * @returns {{ source?: string|null, identifier?: string|number|null, blocks?: unknown[] } | null}
 */
export function readSourcesPickerPack(sessionId) {
	if (!sessionId) {
		return null;
	}

	try {
		const raw = localStorage.getItem(storageKey(sessionId));
		if (!raw) {
			return null;
		}

		const parsed = JSON.parse(raw);
		if (!parsed?.pack || typeof parsed.writtenAt !== 'number') {
			return null;
		}

		if (Date.now() - parsed.writtenAt > SOURCES_PICKER_PACK_TTL_MS) {
			localStorage.removeItem(storageKey(sessionId));
			return null;
		}

		return parsed.pack;
	} catch {
		return null;
	}
}

/**
 * @param {string} sessionId
 */
export function clearSourcesPickerPack(sessionId) {
	if (!sessionId) {
		return;
	}

	try {
		localStorage.removeItem(storageKey(sessionId));
	} catch {
		// Ignore.
	}
}

/**
 * @param {string|null|undefined} key
 * @returns {string|null}
 */
export function sessionIdFromPackStorageKey(key) {
	if (typeof key !== 'string' || !key.startsWith('naxos_sources_picker_pack:')) {
		return null;
	}

	const sessionId = key.slice('naxos_sources_picker_pack:'.length);
	return sessionId || null;
}
